<template>
    <div class="modal-recharge">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">查询所要上传的老人</div>
                <div style="folat:right">
                    <el-button type="danger" @click="closeSelf">关闭</el-button>
                </div>
            </div>
            <div class="modal-body" :style="bodyStyle">
                <el-row>
                    <el-form :model="searchForm" inline ref="searchForm">
                        <div>
                            <el-col :span="24">
                                <el-form-item prop="name">
                                    <el-input  placeholder="请输入姓名" v-model="searchForm.name" clearable style="width:200px;margin-right:10px"></el-input>
                                </el-form-item>
                                
                                <el-button  type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>
                            </el-col>
                        </div>
                    </el-form>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="24">
                        <el-table
                            :data="elderlyInfo"
                            style="width: 100%" border :height="th">
                            <el-table-column label="老人姓名" prop="name" width="100"></el-table-column>
                            <el-table-column label="手机号" prop="phone" width="120"></el-table-column>
                            <el-table-column label="身份证号" prop="idCard" width="200"></el-table-column>
                            <el-table-column prop="balance"  width="100" label="余额(元)"></el-table-column>
                            <el-table-column prop="deposit"  width="100" label="预交金(元)"></el-table-column>
                            <el-table-column prop="imprest"  width="100" label="备用金(元)"></el-table-column>
                            <el-table-column label="地址" prop="areaName"></el-table-column>
                            <el-table-column label="详细住址" prop="address"></el-table-column>
                            
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click.native.prevent="uploadContract(scope.row)">上传</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/searchForm.pageSize)}}页）
                    </div>
                    <div style="float: left;">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="totalItems"
                                :page-size="20"
                                @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>
            </div>
        </div>
        <el-dialog title='合同上传' :visible.sync="batchDialog" @close='closeDialog' :modal-append-to-body='false' width='800px' center top='20vh' :close-on-click-modal='false'>
             <el-alert
                title="合同上传只能上传一种类型文件，默认为图片格式"
                type="warning" style="margin-bottom:15px">
            </el-alert>
             <el-form :model="addForm" label-width="80px">
                <el-row style="text-align: left;">
                    <el-col :span="12">
                        <el-form-item label="合同类型">
                            <el-select v-model="addForm.uploadContractClassCode" placeholder="请选择合同类型">
                                <el-option
                                    v-for="item in uploadContractClassValue"
                                    :key="item.uploadContractClassCode"
                                    :label="item.name"
                                    :value="item.uploadContractClassCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="上传类型">
                            <el-radio-group v-model="addForm.type">
                                <el-radio-button label="1">图片格式</el-radio-button>
                                <el-radio-button label="2">pdf文件</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="24">
                        <el-form-item label="上传图片" v-if="addForm.type==1">
                            <el-upload
                                ref="upload"
                                :action="uploadUrl"
                                :data='uploadData'
                                :on-success="uploadSuccess"
                                list-type="picture-card"
                                :before-upload="handleBeforeUpload"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemove">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="18">
                        <el-form-item label="上传文件" v-if="addForm.type==2">
                            <el-upload
                                class="upload-demo"
                                ref="uploadFile"
                                :action="uploadUrlFile"
                                :data='uploadData'
                                :on-success="onSuccess"
                                :before-upload="beforeUpload"
                                :file-list='fileListFile'>
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
                                <div slot="file" slot-scope="{file}" class="fileClass">
                                    <span> {{file.name}} </span>
                                    <span>
                                        <span style="margin-right:10px"
                                            @click="handleOpen(file)" >
                                            <i class="el-icon-view"></i>
                                        </span>
                                        <span style="margin-right:10px"
                                            @click="handleDownload(file)"
                                            >
                                            <i class="el-icon-download"></i>
                                        </span>
                                        <span @click="onRemove(file)" >
                                            <i class="el-icon-delete"></i>
                                        </span>
                                    </span>
                                </div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="18">
                        <el-form-item label="备注">
                            <el-input type="textarea" rows="3" v-model="addForm.remarks"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-image-viewer
                v-if="imgDialog"
                :on-close="imgClose"
                :url-list="srcList" />
            </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="batchDialog=false">取 消</el-button>
                    <el-button type="primary"  @click="contractSub">提交</el-button>
                </div>
            </el-dialog>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

    export default {
        name: 'Add',
        data() {
            return {
                addForm:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    elderlyCode:"",
                    uploadContractClassCode:"",
                    imgList:[],
                    type:1,
                    remarks:''
                },
                srcList:[],
                imgDialog: false,
                batchDialog: false,
                uploadUrl:this.$institutionUrl+'Upload/Imgs',
                uploadUrlFile:this.$institutionUrl+'Upload/File',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                uploadContractClassValue:[],
                fileList:[],
                fileListFile:[],
                loading: false, 
                elderlyInfo:[],
                elderlyRow:'',
                totalItems:0,
                searchForm:{
                    name:'',
                    status:0,
                    pageSize:20,
                    pageIndex:1,
                },
                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                th:this.$store.state.tableHeight,
                successInfo:''
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.bodyStyle = "height:"+(val+50)+'px';
                this.th=val
            },
        },
        components:{
            ElImageViewer
        },
        methods: {
            init(uploadContractClassValue){
                this.$refs.searchForm.resetFields()
                this.getElderly();
                this.uploadContractClassValue = uploadContractClassValue;
            },
            uploadContract(row){
                this.addForm.elderlyCode = row.elderlyCode;
                this.batchDialog = true;
            },
            closeDialog(){
                this.addForm.uploadContractClassCode="";
                if(this.$refs.upload){
                    this.$refs.upload.clearFiles();
                }else{
                    this.$refs.uploadFile.clearFiles();
                }
                this.addForm.imgList=[];
                this.fileList = [];
            },
            imgClose(){
                this.imgDialog = false;
            },
            uploadSuccess(response,file,fileList){
                if(response.error == 0){
                    this.fileList=fileList;
                }else if(response.error == 1){
                    this.$message({type: 'info', message: response.message});
                }
            },
            handlePictureCardPreview(url){
                this.srcList=[]
                for(var i in this.fileList){
                    this.srcList[i]=this.$imgUrl+this.fileList[i].response.data.path;
                }
                this.srcList=this.getPreviewList(this.$imgUrl+url.response.data.path)
            },
            getPreviewList(url){
                this.imgDialog = true;
                var list=[]
                var list1=this.srcList;
                for(var i in list1){
                    if(list1[i]==url){
                        var str =list1.slice(i)
                        list=str.concat(list)
                        return list
                    }else{
                        list.push(list1[i])
                    }
                }
            },
            handleRemove(file,fileList) {
                this.fileList=fileList;
            },
            handleBeforeUpload(file){
                var type=file.name.slice(file.name.lastIndexOf(".")+1,file.name.length)
                if(type.toLowerCase()!='png'&&type.toLowerCase()!='jpg'){
                    this.$message.error('请上传图片！')
                    return false;
                }
            },
            beforeUpload(file){
                var type=file.name.slice(file.name.lastIndexOf(".")+1,file.name.length)
                if(type.toLowerCase()!='pdf'){
                    this.$message.error('请上传pdf格式的文件！')
                    return false;
                }
            },
            onSuccess(response,file,fileList){
                if(response.error == 0){
                    this.fileListFile=fileList;
                    console.log(this.fileListFile)
                }else if(response.error == 1){
                    this.$message({type: 'info', message: response.message});
                }
            },  
            onRemove(file){
                this.fileListFile=this.fileListFile.filter(function (item) {
                    return item.uid!=file.uid;
                });
            },
            contractSub(){
                if(this.addForm.uploadContractClassCode==""){
                     this.$message.error('请选择合同分类');
                    return;
                }
                var list=this.addForm.type==1?this.fileList:this.fileListFile
                if(list.length==0){
                    this.$message.error('请上传合同文件');
                    return;
                }
                
                let arr= [];
                list.forEach(element => {
                    arr.push(element.response.data.path);
                });
                this.loading=true;
                this.addForm.imgList = arr;
                this.submit();
            },
            
            closeSelf() {
                this.$emit("closeAdd");
            },
            getList(){
                this.$emit("getList");
                this.getElderly();
            },
            current_change:function(currentPage){
                this.searchForm.pageIndex = currentPage;
                this.getElderly();
            },
            handleOpen(file){
                window.open(this.$imgUrl+file.response.data.path)
            },
            handleDownload(file){
                let fileName = file.name;
                this.$axios.get(this.$institutionUrl + 'FileDownload/Download?url='+file.response.data.path,{
                    responseType: 'blob',
                }).then(    
                    (response) => {
                        this.$emit("downloadFile",response.data, fileName);
                    }
                )
            },
            getElderly(){
                this.searchForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.searchForm.timeStr = timeStr
                this.searchForm.staffCode = getStaffCode()
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/Page",
                    data: this.searchForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.elderlyInfo=response.data.data.list;
                            this.totalItems = response.data.data.total;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            submit(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"UploadContractItem/Add",
                    data: this.addForm
                }).then(
                    (response) => {
                        console.log(response);
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.closeDialog();
                            this.batchDialog=false;
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            }
            
        }
    }


</script>





<style lang="scss" scoped>
    
    .modal-recharge {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;
        .dialog /deep/ .is-disabled .el-input__inner {
            background-color: #F5F7FA;
            border-color: #E4E7ED;
            color: #000;
            cursor: not-allowed;
        }
        .text{
            font-size: 16px;
            line-height: 25px;
        }
        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            
            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-body /deep/ .el-form-item{
                margin: 0 5px 0 0;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }
        

    }
    /deep/  .el-icon-circle-close:before {
        color: #fff;
    }
    .fileClass{
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
    }
    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
